// extracted by mini-css-extract-plugin
export default {"btn":"FormFeedback_btn__iZRAT"};